import { useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { DialogWrapper } from "components/shared/dialog";
import { postAboutMe } from "adapters";
import { useDispatch, useSelector } from "react-redux";
import { GetUrlBuilderData, SetUrlBuilderData } from "store/url-builder";
import { useParams } from "react-router-dom";
import { RichTextEditor } from "components/shared/rich-text-editor";
import { Box } from "@material-ui/core";

import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";

export interface EditAboutMeDialogProps {
  isOpen: boolean;
  onClose(): void;
  builderType: string;
}

export const EditAboutMeDialog = ({
  isOpen,
  onClose,
  builderType,
}: EditAboutMeDialogProps) => {
  const [loading, setLoading] = useState(false);
  const builderData = useSelector(GetUrlBuilderData);
  const [editorState, setEditorState] = useState<any>();
  const dispatch = useDispatch();
  const { cardId }: { cardId: string } = useParams();

  const submit = () => {
    setLoading(true);

    if (!editorState?.getCurrentContent()) {
      onClose();
      setLoading(false);
      return;
    }

    const markup = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    const aboutMeHtmlInput = editorState
      ? markup === "<p></p>"
        ? ""
        : markup
      : "";

    postAboutMe(cardId, builderType, aboutMeHtmlInput)
      .then(({ data }) => {
        if (!data.success) return;
        dispatch(SetUrlBuilderData(data.data));
        onClose();
      })
      .finally(() => setLoading(false));
  };

  return (
    <DialogWrapper
      open={isOpen}
      onClose={onClose}
      loading={loading}
      onSubmit={submit}
      title="About Me"
      enableFullScreen
    >
      <Box minHeight="40vh">
        <RichTextEditor
          onChange={setEditorState}
          initialState={builderData.aboutMe.text}
        />
      </Box>
    </DialogWrapper>
  );
};
